import { RowCrudStatus } from "../../common/types";
import { AssociatedDocumentSignedEdition } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { FileCRUDType, fileCRUDInit } from "../../common/types";
import { formatBytes } from "../../../common/utils";

let uniqueCounter = 1;
export type AssociatedDocumentSignedEditionValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  file: string;
  file_data: FileCRUDType;
  __file_files: FileCRUDType[];
};

export type AssociatedDocumentSignedEditionErrorsType = {
  name?: { message: string; fieldLabel: string };
  file?: { message: string; fieldLabel: string };
};

export function AssociatedDocumentSignedEditionValuesInit(): AssociatedDocumentSignedEditionValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    file: "",
    file_data: fileCRUDInit(),
    __file_files: [],
  };
}

export type AssociatedDocumentSignedEditionType =
  | AssociatedDocumentSignedEdition
  | AssociatedDocumentSignedEditionValuesType;

export function associatedDocumentSignedEditionDisplayId(
  source: Partial<AssociatedDocumentSignedEdition>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getAssociatedDocumentSignedEditionValues(
  source: AssociatedDocumentSignedEditionType,
  _langStore: LangStore,
  _duplicated: boolean = false
): AssociatedDocumentSignedEditionValuesType {
  const entityValues = AssociatedDocumentSignedEditionValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : associatedDocumentSignedEditionDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.__file_files =
    source.file_data && !_duplicated
      ? [
          {
            id:
              "id" in source.file_data && source.file_data.id
                ? source.file_data.id
                : `generated_${uniqueCounter++}`,
            name: source.file_data.name,
            description: source.file_data.description || undefined,
            size: source.file_data.size || 0,
            formattedSize: source.file_data.size
              ? formatBytes(source.file_data.size)
              : "",
            mimetype: source.file_data.mimetype,
            url: source.file_data.url || undefined,
            __status__: "original",
          },
        ]
      : [];
  entityValues.file = source.file && !_duplicated ? source.file : "";
  entityValues.file_data =
    source.file_data && "__status__" in source.file_data
      ? source.file_data
      : source.file_data
      ? {
          id: ("id" in source.file_data && source.file_data.id
            ? source.file_data.id
            : `generated_${uniqueCounter++}`) as string,
          name: source.file_data.name,
          description: source.file_data.description || undefined,
          size: source.file_data.size || 0,
          formattedSize: source.file_data.size
            ? formatBytes(source.file_data.size)
            : "",
          mimetype: source.file_data.mimetype,
          url: source.file_data.url || undefined,
          __status__: "original" as RowCrudStatus,
        }
      : fileCRUDInit();
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
